"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepfunctionsUninstrumentCommand = void 0;
const clipanion_1 = require("clipanion");
const plugin_1 = require("../../helpers/plugin");
const __1 = require("../..");
class StepfunctionsUninstrumentCommand extends __1.BaseCommand {
    constructor() {
        super(...arguments);
        this.dryRun = clipanion_1.Option.Boolean('-d,--dry-run', false);
        this.stepFunctionArns = clipanion_1.Option.Array('-s,--step-function');
        // The options below are to match what InstrumentStepFunctionsCommand has so that customers can switch from instrument to uninstrument.
        // Lambda command adopts the same approach as well.
        this.environment = clipanion_1.Option.String('-e,--env', { hidden: true });
        this.forwarderArn = clipanion_1.Option.String('--forwarder', { hidden: true });
        this.service = clipanion_1.Option.String('--service', { hidden: true });
        this.mergeStepFunctionAndLambdaTraces = clipanion_1.Option.Boolean('-mlt,--merge-lambda-traces,--merge-step-function-and-lambda-traces', false, { hidden: true });
        this.fips = clipanion_1.Option.Boolean('--fips', false);
        this.fipsIgnoreError = clipanion_1.Option.Boolean('--fips-ignore-error', false);
    }
    execute() {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, plugin_1.executePluginCommand)(this);
        });
    }
}
exports.StepfunctionsUninstrumentCommand = StepfunctionsUninstrumentCommand;
StepfunctionsUninstrumentCommand.paths = [['stepfunctions', 'uninstrument']];
StepfunctionsUninstrumentCommand.usage = clipanion_1.Command.Usage({
    category: 'Serverless',
    description: 'Remove Step Function log groups subscription filter created by datadog-ci.',
    details: '--stepfunction expects a Step Function ARN',
    examples: [
        [
            'View and apply changes to remove Step Functions log groups subscription filters created by datadog-ci',
            'datadog-ci stepfunctions uninstrument --step-function arn:aws:states:us-east-1:000000000000:stateMachine:ExampleStepFunction',
        ],
        [
            'View changes to remove Step Functions log groups subscription filters created by datadog-ci',
            'datadog-ci stepfunctions uninstrument --step-function arn:aws:states:us-east-1:000000000000:stateMachine:ExampleStepFunction --dry-run',
        ],
        [
            'View and apply changes to remove Step Functions log groups subscription filters created by datadog-ci',
            'datadog-ci stepfunctions uninstrument --step-function arn:aws:states:us-east-1:000000000000:stateMachine:ExampleStepFunction1 --step-function arn:aws:states:us-east-1:000000000000:stateMachine:ExampleStepFunction2',
        ],
    ],
});
//# sourceMappingURL=uninstrument.js.map